var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"gitModal",attrs:{"id":"confirm-dialog","modal-class":_vm.theme,"title":_vm.title,"hide-footer":"","centered":"","body-class":"modal__confirm","size":_vm.size}},[_c('GitConfig',{attrs:{"type":_vm.type,"serviceName":_vm.serviceName},on:{"close":_vm.onClose,"resizeDialog":_vm.resize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }